import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { doc, getDoc, updateDoc, arrayUnion, serverTimestamp } from 'firebase/firestore';
import { useAuth } from "../../../utils/AuthContext/authcontext";
import ContactSidebar from './../../ContactSidebar/ContactSidebar';
import CompactNavbar from './../../CompactNavbar/CompactNavbar';
import AuthToggle from './../../AuthToggle/AuthToggle';
import Button from '../../ui/Button';
import { storage, firestore, auth }  from "../../../firebase/firebase.js";
import styles from './InviteJoin.module.css';

//const redirect = localStorage.getItem('postLoginRedirect');
//console.log(redirect);
//if (redirect) {
//  localStorage.removeItem('postLoginRedirect');
//  window.location.replace(redirect);
//}

export default function InviteJoin() {
  const { user, userData, logout, login, loading} = useAuth();
  const location = useLocation();
  const [status, setStatus] = useState('pending');
  const [isredirect, setRedirect] = useState(false);
  //const [emailaddress, setEmailaddress] = useState(null);
  const [isLoginOpen, setLoginOpen] = useState(false);
  const [isContactOpen, setContactOpen] = useState(false);
  const query = new URLSearchParams(location.search);
  const arenaId = query.get('arena');
  const token = query.get('token');
  const email = query.get('email');
  const navigate = useNavigate();

  useEffect(() => {
	if(isredirect == true && !user && isLoginOpen == false) {
		//localStorage.setItem('postLoginRedirect', window.location.href);
		//console.log(window.location.href);
		//navigate('/login');
		setStatus('error');
	}
  }, [isLoginOpen]);

  useEffect(() => {
	if(isredirect == true) {
		localStorage.setItem('postLoginRedirect', window.location.href);
		//console.log(window.location.href);
		setLoginOpen(true);
	}
  }, [isredirect]);
  
  
	const mlogout = () => {
	}


  useEffect(() => {
	if (!arenaId || !token) return setStatus('invalid');

    if (loading) return;

    if (!user) {
	  setRedirect(true);
      return;
    }

    const arenaRef = doc(firestore, 'arenas', arenaId);

    getDoc(arenaRef).then(docSnap => {
      if (!docSnap.exists()) return setStatus('not-found');
      const arena = docSnap.data();

      // Moderator claim
      const mod = arena.roles?.moderator;
      if (mod?.inviteToken === token && mod.email === user.email && !mod.uid) {
        arena.roles.moderator = { ...arena.roles.moderator, role: "Joined", uid: userData.uid, email: userData.email, username: userData.username || '', profilePicture: userData.profilePicture};
		return updateDoc(arenaRef, {
				'roles.moderator': arena.roles.moderator
			}).then(() => {
          setStatus('success');
          setTimeout(() => navigate(`/debates/${arenaId}`), 1500);
        }).catch(() => setStatus('error'));
      }

      // Debater claim
      const idx = arena.roles.debaters.findIndex(
        d => d.inviteToken === token && d.email === user.email && !d.uid
      );

      if (idx !== -1) {
	    arena.roles.debaters[idx] = { ...arena.roles.debaters[idx], role: "Joined", uid: userData.uid, email: userData.email, username: userData.username || '', profilePicture: userData.profilePicture};
 
		return updateDoc(arenaRef, {
			'roles.debaters': arena.roles.debaters
		}).then(() => {
          setStatus('success');
          setTimeout(() => navigate(`/debates/${arenaId}`), 1500);
        }).catch(() => setStatus('error'));
      }

      setStatus('invalid');
    }).catch(() => setStatus('error'));
  }, [arenaId, token, user, loading]);

  const messages = {
    pending: 'Checking your invite...',
    invalid: 'This invite link is invalid or expired.',
    not_found: 'Debate not found.',
    success: 'You are successfully invited! Redirecting...',
    error: 'Something went wrong. Please try again later.',
  };
  
	 return (
	  <>
	<div className={styles.headernav}>
		<CompactNavbar shownow={false} modal={true} scrollY={0} openContact={() => setContactOpen(true)}  openLogin={(user) => {user != null ? logout(true) : mlogout()}}/>
	</div>
	  <div className={styles.container}>
		<div className={styles.card}>
		  <h1 className={styles.title}>Join Debate Invite</h1>
		  <p className={styles.message}>{messages[status] || messages.invalid}</p>

		  {status === 'wrong_email' && (
			<Button variant="secondary" className={styles.actionBtn} onClick={() =>  navigate('/login')}>  Sign in with invited email </Button>
		  )}

		  {['invalid', 'not_found', 'error'].includes(status) && (
			<>
			  <Button variant="secondary" className={styles.actionBtn} onClick={() => navigate('/home')}> Return Home </Button>
			</>
		  )}

		  {status === 'pending' && <div className={styles.loader}>?</div>}
		</div>
	  </div>
	  <AuthToggle settings={{email: email}} isLOpen={isLoginOpen} onLClose={() => setLoginOpen(false)} />
	  <ContactSidebar isOpen={isContactOpen} onClose={() => setContactOpen(false)} />
	  </>
	);

  
}
